module.exports = __webpack_public_path__ + "img/event-2024-fusion-blues.f49f3c1.jpg";